/**
 * Extended WebSocket protocol for multi-terminal support
 * Adds sessionId routing to all messages
 */
export function parseTerminalWsServerMessage(text) {
    try {
        const parsed = JSON.parse(text);
        if (!parsed || typeof parsed !== 'object')
            return null;
        const msg = parsed;
        if (typeof msg.type !== 'string')
            return null;
        return {
            type: msg.type,
            sessionId: typeof msg.sessionId === 'string' ? msg.sessionId : undefined,
            data: msg.data,
        };
    }
    catch {
        return null;
    }
}
/**
 * Encode messages with optional sessionId for multi-terminal support
 */
export function encodeTerminalWsInput(data, sessionId) {
    return JSON.stringify({
        type: 'input',
        ...(sessionId && { sessionId }),
        data: { data },
    });
}
export function encodeTerminalWsResize(rows, cols, sessionId) {
    return JSON.stringify({
        type: 'resize',
        ...(sessionId && { sessionId }),
        data: { rows, cols },
    });
}
export function encodeTerminalWsPing(sessionId) {
    return JSON.stringify({
        type: 'ping',
        ...(sessionId && { sessionId }),
    });
}
/**
 * New message encoders for multi-terminal operations
 */
export function encodeTerminalWsCreateSession(sessionId, rows, cols, name, workDir) {
    return JSON.stringify({
        type: 'create_session',
        data: { sessionId, rows, cols, ...(name && { name }), ...(workDir && { workDir }) },
    });
}
export function encodeTerminalWsCloseSession(sessionId) {
    return JSON.stringify({
        type: 'close_session',
        data: { sessionId },
    });
}
export function encodeTerminalWsRenameSession(sessionId, name) {
    return JSON.stringify({
        type: 'rename_session',
        data: { sessionId, name },
    });
}
/**
 * Helper to check if a message is for a specific session
 */
export function isMessageForSession(msg, sessionId) {
    // Check if this message type supports sessionId
    if ('sessionId' in msg) {
        return msg.sessionId === sessionId;
    }
    // Messages without sessionId are not session-specific
    return false;
}
/**
 * Type guards for specific message types
 */
export function isOutputMessage(msg) {
    return msg.type === 'output';
}
export function isSessionCreatedMessage(msg) {
    return msg.type === 'session_created';
}
export function isSessionClosedMessage(msg) {
    return msg.type === 'session_closed';
}
export function isErrorMessage(msg) {
    return msg.type === 'error';
}
export function isSessionReattachedMessage(msg) {
    return msg.type === 'session_reattached';
}
export function isScrollbackMessage(msg) {
    return msg.type === 'scrollback';
}
export function isSessionListMessage(msg) {
    return msg.type === 'session_list';
}
/**
 * New message encoders for session persistence
 */
export function encodeTerminalWsListSessions() {
    return JSON.stringify({ type: 'list_sessions' });
}
export function encodeTerminalWsReattachSession(sessionId, rows, cols) {
    return JSON.stringify({
        type: 'reattach_session',
        data: { sessionId, rows, cols },
    });
}
//# sourceMappingURL=protocol.js.map